import { all } from 'redux-saga/effects'
import gocarSagas from './gocar/saga'
import registerSagas from './register/saga'
import LoadingSaga from './loading/saga'
import ErrorSaga from './error/saga'

export default function* rootSaga(getState) {
  yield all([
    gocarSagas(),
    registerSagas(),
    LoadingSaga(),
    ErrorSaga()
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js